/* Cactus Warehouse product page behaviour.
   1. Moves the Klaviyo Back In Stock trigger button into the restock box.
   2. Keeps the restock box copy and the in stock nudge in sync with the selected variant.
   Sold out visibility itself is CSS, driven by the data-cw-sold attribute on .js-product. */

(function cwProduct() {
  var TRIGGER_SELECTOR = '.cw-bis-trigger, .klaviyo-bis-trigger';

  function slotFor(node) {
    var product = node.closest ? node.closest('.js-product') : null;
    if (product) return product.querySelector('[data-cw-restock-trigger]');
    return document.querySelector('[data-cw-restock-trigger]');
  }

  function placeTrigger(node) {
    if (!node || node.dataset.cwPlaced === 'true') return;
    var slot = slotFor(node);
    if (!slot || slot.contains(node)) return;
    slot.appendChild(node);
    node.dataset.cwPlaced = 'true';
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(TRIGGER_SELECTOR)) placeTrigger(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(TRIGGER_SELECTOR), placeTrigger);
    }
  }

  function watch() {
    if (!document.querySelector('[data-cw-restock-trigger]')) return;
    scan(document.body);

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, scan);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function syncVariant(evt) {
    var detail = evt.detail || {};
    var variant = detail.variant;
    var box = evt.target.closest ? evt.target.closest('.js-product') : null;
    var scope = box || document;

    var nameEl = scope.querySelector('[data-cw-restock-variant]');
    if (nameEl && variant && variant.title) nameEl.textContent = variant.title;

    var nudge = scope.querySelector('[data-cw-nudge]');
    if (nudge) {
      var sameVariant = variant && String(variant.id) === nudge.dataset.cwNudgeId;
      nudge.hidden = Boolean(sameVariant);
    }
  }

  function init() {
    watch();
    document.addEventListener('on:variant:change', syncVariant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());


/* Complementary "pairs" block: never blank. When the recommendations API
   returns fewer products than the block wants, top up from the fallback
   list; when it returns nothing, show the fallback list instead. */
(function cwPairs() {
  function settle(rec) {
    var block = rec.closest('.cw-complementary');
    if (!block) return;
    var fb = block.querySelector('[data-cw-comp-fallback]');
    var max = fb ? parseInt(fb.dataset.cwCompMax, 10) || 3 : 3;
    var list = rec.querySelector('ul');
    var have = list ? list.querySelectorAll('li').length : 0;
    if (!fb) { block.classList.toggle('cw-complementary--empty', have === 0); return; }
    var spare = Array.prototype.slice.call(fb.querySelectorAll('li[data-cw-fb-handle]'));
    if (have === 0) {
      fb.hidden = spare.length === 0;
      block.classList.toggle('cw-complementary--empty', spare.length === 0);
      return;
    }
    fb.hidden = true;
    var present = Array.prototype.map.call(list.querySelectorAll('a[href*="/products/"]'), function (a) {
      return a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
    });
    spare.forEach(function (li) {
      if (have >= max) return;
      if (present.indexOf(li.dataset.cwFbHandle) !== -1) return;
      list.appendChild(li);
      have += 1;
    });
    if (window.initLazyImages) window.initLazyImages();
  }

  function arm() {
    document.querySelectorAll('.cw-complementary product-recommendations').forEach(function (rec) {
      if (rec.dataset.cwPairsArmed) return;
      rec.dataset.cwPairsArmed = '1';
      new MutationObserver(function () { settle(rec); }).observe(rec, { childList: true });
      /* Lazy init waits for the element to near the viewport; if the API
         has answered with nothing by then, the observer never fires, so
         settle once the element is visible plus a grace period. */
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !seen) { seen = true; setTimeout(function () { settle(rec); }, 2500); io.disconnect(); }
        });
      }, { rootMargin: '600px' });
      io.observe(rec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
